module.exports = __webpack_public_path__ + "static/media/img-relocation.08045961.png";